var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { WinningAmountTypeEnum } from "../../../../../models/modules/lotteryplatofrm.models";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { computedFrom } from "aurelia-binding";
var SweepstakePrizeTiers = /** @class */ (function (_super) {
    __extends(SweepstakePrizeTiers, _super);
    function SweepstakePrizeTiers(notificationService, i18N) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.canUpdatePrizeTier = true;
        _this.isWinningRangeRequired = true;
        return _this;
    }
    SweepstakePrizeTiers.prototype.onActivated = function (item) {
        if (!item.sweepstakePrizeTiers)
            item.sweepstakePrizeTiers = [];
    };
    SweepstakePrizeTiers.prototype.removePrizeTier = function (item) {
        var index = this.item.sweepstakePrizeTiers.indexOf(item);
        this.item.sweepstakePrizeTiers.splice(index, 1);
    };
    Object.defineProperty(SweepstakePrizeTiers.prototype, "gameCurrency", {
        get: function () {
            return this.item.currency ? this.item.currency.symbol : '';
        },
        enumerable: false,
        configurable: true
    });
    SweepstakePrizeTiers.prototype.getStaticWinningAmountTypeValue = function () {
        return WinningAmountTypeEnum.Static;
    };
    SweepstakePrizeTiers.prototype.getDynamicByContributionWinningAmountTypeValue = function () {
        return WinningAmountTypeEnum.DynamicByContribution;
    };
    SweepstakePrizeTiers.prototype.addPrizeTier = function () {
        var tier = {
            sweepstakePrizeTierId: 0,
            name: "",
            internalName: "",
            insuranceTierName: "",
            sweepstakeId: this.item.sweepstakeId,
            sequenceNumber: 0,
            numberOfWinners: 0,
            hasMonetaryValue: false,
            nonMonetaryPrizeText: null,
            winningAmount: null,
            winningAmountTypeId: null,
            minimumWinningAmountThreshold: null,
            percentageOfContribution: null
        };
        this.item.sweepstakePrizeTiers.push(tier);
    };
    __decorate([
        computedFrom("item.currency.symbol"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SweepstakePrizeTiers.prototype, "gameCurrency", null);
    SweepstakePrizeTiers = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N])
    ], SweepstakePrizeTiers);
    return SweepstakePrizeTiers;
}(ChildComponent));
export { SweepstakePrizeTiers };
